// Fuente única de "qué día es hoy" para todo el sistema (backend y
// frontend importan este mismo archivo desde shared/). Antes, Agenda,
// Mi Trabajo, Dashboard y Centro de Operaciones calculaban "hoy" con
// `new Date().toISOString().substring(0, 10)` en JS o `date('now')` en
// SQLite — ambos son UTC. Entre las 21:00 y las 24:00 hora Mendoza eso hace
// que el sistema crea que ya es el día siguiente (Argentina es UTC-3 fijo,
// sin horario de verano desde 2009). Se usa el nombre IANA de la zona en
// vez de un offset fijo "-03:00" para que Intl resuelva el offset correcto
// automáticamente si esa regla cambiara.
export const ZONA_HORARIA_SISTEMA = "America/Argentina/Mendoza";

const FORMATO_FECHA_SISTEMA = new Intl.DateTimeFormat("en-CA", {
  timeZone: ZONA_HORARIA_SISTEMA,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

// Día calendario (YYYY-MM-DD) de un instante, en la zona horaria del
// sistema. Reemplaza cualquier comparación de "hoy"/"vencido"/"audiencias
// de hoy" que antes usaba UTC. No usar para diferencias de tiempo
// transcurrido (esas ya son correctas comparando dos instantes UTC entre
// sí — el problema es sólo de límite de día calendario, no de duración).
export function fechaHoyEnZonaSistema(instante: Date = new Date()): string {
  return FORMATO_FECHA_SISTEMA.format(instante);
}

// "Hoy" (zona del sistema) representado como medianoche UTC de ese mismo
// día — para código que ya hace aritmética de calendario sobre un objeto
// Date con getUTC*()/toISOString() (sumar días, encontrar el lunes de la
// semana, etc.). Envolver ese "hoy" con esta función alcanza para corregir
// esa aritmética sin tocar su lógica interna: sigue operando en UTC, sólo
// que ahora sobre el día calendario correcto en vez del día UTC del reloj.
export function hoyComoFechaUtc(instante: Date = new Date()): Date {
  return new Date(`${fechaHoyEnZonaSistema(instante)}T00:00:00Z`);
}
